import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHorizontalAlignmentTop"><Path d="M3.5 3.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 6.5V16.5H17.5V6.5H13.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 6.5V20.5H10.5V6.5H6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHorizontalAlignmentTop;
